import Home from './pages/HeroSection/Home';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
